import { authClient } from '@/lib/auth-client';
import expandRoles from 'lib/expandRoles';
import type { Role } from 'lib/models/roles';

export default function useAuth() {
  const { data: session } = authClient.useSession();
  const roles = expandRoles((session?.user.roles ?? []) as Role[]);

  return {
    isAdmin: roles.has('admin'),
    canWrite: roles.has('contributor'),
    canRead: roles.has('reader'),
  };
}
